<template>
  <section class="about-page">
    <!-- Hero / Intro Section -->
    <div class="hero-section">
      <div class="hero-overlay"></div>
      <div class="hero-content text-center">
        <h1 class="fw-bold">About GAA Africa International</h1>
        <p class="lead">
          Connecting Africa with the world through travel, education, corporate services, and investments.
        </p>
      </div>
    </div>

    <!-- Main Content Section -->
    <div class="container content-section py-5">
      <div class="row align-items-center">
        <div class="col-md-6">
          <p>
            GAA Africa International is a leading African-based enterprise providing comprehensive solutions 
            in travel, migration, education, corporate services, and investment facilitation. 
          </p>
          <p>
            With a proven track record of excellence, we serve individuals, corporate organizations, 
            and institutions by offering innovative, reliable, and world-class services.
          </p>
          <h4 class="mt-4">Our Areas of Specialization Include:</h4>
          <ul class="specialization-list">
            <li>Travel Agency & Corporate Travel Solutions</li>
            <li>Migration Management Services</li>
            <li>Educational Destination Consulting</li>
            <li>Tour Operations & Holiday Packages</li>
            <li>Conference & Event Management</li>
            <li>Investment & Trade Facilitation</li>
          </ul>
        </div>
        <div class="col-md-6 text-center">
          <img src="@/assets/images/about1.jpg" alt="About GAA Africa" class="about-image">
        </div>
      </div>

      <div class="mission-section mt-5 text-center">
        <h4>Our Mission</h4>
        <p class="mt-3">
          We are driven by a mission to connect Africa with the world through seamless travel, impactful education, business exchange, 
          and international partnerships. Guided by professionalism, integrity, and customer satisfaction, 
          GAA Africa International stands as a trusted partner for global opportunities.
        </p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "AboutPage",
};
</script>

<style scoped>
/* Hero Section */
.hero-section {
  position: relative;
  height: 50vh;
  background: url("@/assets/images/about-hero.jpg") center center/cover no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.hero-content {
  position: relative;
  z-index: 1;
  max-width: 800px;
}

.hero-content h1 {
  font-size: 3rem;
  margin-bottom: 15px;
}

.hero-content p {
  font-size: 1.25rem;
}

/* Content Section */
.content-section {
  background-color: #f9f9f9;
  border-radius: 15px;
  padding: 3rem 2rem;
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.1);
}

.about-image {
  width: 100%;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
}

.specialization-list {
  list-style: none;
  padding: 0;
  margin-top: 1rem;
}

.specialization-list li {
  position: relative;
  padding-left: 25px;
  margin-bottom: 0.5rem;
  font-size: 1.05rem;
  line-height: 1.7;
}

.specialization-list li::before {
  content: '';
  position: absolute;
  left: 0;
  top: 8px;
  width: 10px;
  height: 10px;
  background-color: #004aad;
  border-radius: 50%;
}

/* Mission Section */
.mission-section {
  max-width: 800px;
  margin: 3rem auto 0 auto;
}

.mission-section h4 {
  font-size: 1.75rem;
  color: #004aad;
  font-weight: 600;
}

.mission-section p {
  font-size: 1.1rem;
  line-height: 1.8;
  color: #333;
}

/* Responsive */
@media (max-width: 768px) {
  .hero-content h1 {
    font-size: 2rem;
  }
  .hero-content p {
    font-size: 1rem;
  }
  .content-section {
    padding: 2rem 1rem;
  }
}
</style>
